import React from 'react';
import {AutoLinkPlugin as LinkPlugin} from '@lexical/react/LexicalAutoLinkPlugin';
import {EMAIL_MATCHER} from '@priority-software/priority-utils/lib/email';
import {URL_MATCHER} from './constants';

const MATCHERS = [
    (text: string) => {
        const match = URL_MATCHER.exec(text);
        return (
            match && {
                index: match.index,
                length: match[0].length,
                text: match[0],
                url: match[0]
            }
        );
    },
    (text: string) => {
        const match = EMAIL_MATCHER.exec(text);
        return (
            match && {
                index: match.index,
                length: match[0].length,
                text: match[0],
                url: `mailto:${match[0]}`
            }
        );
    }
];

export function AutoLinkPlugin() {
    return <LinkPlugin matchers={MATCHERS} />;
}
